export default import.meta.ROLLDOWN_FILE_URL_t9FUCRck5mI3Q3fZmXY_eg